function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "web-development",
  d: "M29,418.934A2.934,2.934,0,0,0,26.066,416H6.934A2.934,2.934,0,0,0,4,418.934v14.132A2.934,2.934,0,0,0,6.934,436H26.066A2.934,2.934,0,0,0,29,433.066Zm-10.893,6.852,2.714,2.714-2.714,2.714a.625.625,0,0,0,.884.884l3.157-3.157a.625.625,0,0,0,0-.884L18.991,424.9a.625.625,0,0,0-.884.884Zm-4.1-.884-3.157,3.157a.625.625,0,0,0,0,.884l3.157,3.157a.625.625,0,0,0,.884-.884L12.179,428.5l2.714-2.714a.625.625,0,0,0-.884-.884Zm13.741-4.526H5.25v-1.441a1.684,1.684,0,0,1,1.684-1.684H26.066a1.684,1.684,0,0,1,1.684,1.684Z",
  transform: "translate(-4 -416)",
  fillRule: "evenodd"
});

function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.36157240.svg";
export { ForwardRef as ReactComponent };